import { render } from "./Breadcrumbs.vue?vue&type=template&id=5db70ca0&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=5db70ca0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5db70ca0"

export default script